import React, { useEffect, useState } from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG, PRODUCT_NAME } from './constants';
interface TimeUnitProps {
  value: number;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="text-center" data-id="element-121" data-mp="1i411jas91xhp">
      <div className="rounded-lg bg-brand-ink px-2.5 py-1.5 font-mono text-xl font-bold text-white shadow-inner sm:px-3 sm:text-2xl" data-id="element-122" data-mp="1i4so5w3vckvu">
        {String(value).padStart(2, '0')}
      </div>
      <p className="mt-0.5 text-[9px] font-extrabold tracking-wider text-brand-slate" data-id="element-123" data-mp="29unlog1vrgvl">{label}</p>
    </div>;
}
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds > 0) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes > 0) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours > 0) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 1,
          minutes: 30,
          seconds: 5
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="border-y border-brand-gold/35 bg-brand-cloud px-4 py-7" data-id="element-124" data-mp="2xtm2lfs8lzej">
      <div className="mx-auto max-w-2xl" data-id="element-125" data-mp="2jtuiqyf1hosm">
        <div className="mb-3 text-center" data-id="element-126" data-mp="2jst5cnajwq7q">
          <p className="mb-1 text-xs font-extrabold uppercase tracking-widest text-brand-blue sm:text-sm" data-id="element-127" data-mp="2jvxg63iiuk7d">
            SPECIAL OFFER — COMPLETE 6-IN-1 SYSTEM
          </p>
          <p className="mb-2 text-sm font-bold text-brand-ink sm:text-base" data-id="element-128" data-mp="29x7yaaqmkzr4">
            Get instant access today and completely transform the way you plan and deliver occupational therapy.
          </p>
          <div className="mb-2 inline-block rounded-lg bg-brand-navy px-3 py-1.5 text-white shadow-md" data-id="element-129" data-mp="84tjhkjdobex">
            <p className="font-display text-sm font-bold tracking-wide sm:text-base" data-id="element-130" data-mp="d2lmpaph3jyf">
              💪 {PRODUCT_NAME} — Complete 6-in-1 System
            </p>
          </div>
          <a href={CHECKOUT_URL} className="block cursor-pointer" aria-label="Purchase Occupational Therapist Pro" data-id="element-131" data-mp="6m3ekt897k4q">
            <img src={PRODUCT_IMG} alt="Occupational Therapist Pro complete 6-in-1 planning system" className="mx-auto mb-2 w-full max-w-[260px] object-contain drop-shadow-xl transition-transform duration-200 hover:scale-[1.02] sm:max-w-xs" data-id="element-132" data-mp="1ojw1h4iwl6z" />
          </a>
        </div>

        <div className="mb-3 rounded-2xl border-4 border-brand-gold bg-white p-4 text-center shadow-2xl sm:p-5" data-id="element-133" data-mp="pfys4s5pi69s">
          <p className="mb-1 text-sm font-bold text-brand-slate" data-id="element-134" data-mp="glan9341mqli">
            Regular Price: <span className="line-through" data-id="element-135" data-mp="gj7xmk6syzhb">$97</span>
          </p>
          <p className="mb-1 text-base font-extrabold uppercase tracking-wide text-brand-blue sm:text-lg" data-id="element-136" data-mp="1d407ajxe4ky6">
            🔥 72% OFF — LIMITED-TIME LAUNCH OFFER
          </p>
          <p className="font-display text-4xl font-extrabold text-brand-ink sm:text-5xl" data-id="element-137" data-mp="2qzrvxbaosff1">Today Only: $27 USD</p>
          <p className="mb-3 text-xs font-bold text-brand-slate" data-id="element-138" data-mp="2vzcsjf2dwbol">Pay securely in your local currency.</p>

          <div className="mb-4 rounded-xl border border-brand-blue/25 bg-brand-mint p-3" data-id="element-139" data-mp="2zyvfshhogyul">
            <p className="mb-2 text-xs font-extrabold uppercase leading-snug tracking-wide text-brand-navy sm:text-sm" data-id="element-140" data-mp="3502k26km3fwi">
              🔥 Last Chance! This special price expires when the countdown reaches zero.
            </p>
            <div className="flex items-start justify-center gap-2.5" data-id="element-141" data-mp="3evmbafo8dqex">
              <TimeUnit value={timeLeft.hours} label="HOURS" data-id="element-142" data-mp="3joyprwz74gty" />
              <span className="mt-1 text-xl font-bold text-brand-slate" data-id="element-143" data-mp="3nphj5vgqluy9">:</span>
              <TimeUnit value={timeLeft.minutes} label="MINUTES" data-id="element-144" data-mp="3nrlkc5n94fuu" />
              <span className="mt-1 text-xl font-bold text-brand-slate" data-id="element-145" data-mp="3spwuyildeue4">:</span>
              <TimeUnit value={timeLeft.seconds} label="SECONDS" data-id="element-146" data-mp="1hhp82an0qlg" />
            </div>
          </div>
          <CTAButton href={CHECKOUT_URL} className="border-brand-navy/25 !bg-brand-gold !text-brand-ink shadow-[0_4px_14px_0_rgba(185,138,53,0.28)] hover:!bg-[#c99b47]" data-id="element-147" data-mp="3k06d392l4jj4">
            🚀 YES! I WANT MY COMPLETE 6-IN-1 SYSTEM
          </CTAButton>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-bold text-brand-ink sm:text-sm" data-id="element-148" data-mp="3or50eslzqhvv">
          <div className="flex items-center gap-1" data-id="element-149" data-mp="312m132kx5ffx">
            <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" data-id="element-150" data-mp="2w394hq48wu05" />
            <span data-id="element-151" data-mp="2w5dgkvcaszbi">⭐ 4.9/5 — Verified Therapist Reviews</span>
          </div>
          <span className="hidden text-brand-line sm:inline" data-id="element-152" data-mp="3b1uofcla3vtb">•</span>
          <div className="flex items-center gap-1" data-id="element-153" data-mp="360x7t4fx39tx">
            <ShieldCheckIcon className="h-4 w-4 text-brand-blue" data-id="element-154" data-mp="363jihcy3u5gd" />
            <span data-id="element-155" data-mp="q8his86im1pl">🛡️ 7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}